import { useSyncExternalStore } from "react";

import type { SlideSettingMap } from "../SettingsPayload";
import { generationSettingStore } from "../store/SettingsGenerationSettingStore";

/** スライド設定のマップ全体を購読する。画面A の一覧が使う。 */
export function useSlides(): SlideSettingMap {
    return useSyncExternalStore(
        (cb) => generationSettingStore.subscribeSlides(cb),
        () => generationSettingStore.getSlides()
    );
}
